import UsersManager from './UsersManager'

export default UsersManager
